export default __webpack_public_path__ + "static/media/map-trifold-fill.3f9a75c5.svg";